export default {
  path: '/artworkArchive',
  name: '',
  component: () => import('@/components/layout/layout.vue'),
  redirect: '/artworkArchive/home',
  children: [
    {
      path: 'index',
      name: 'artworkArchive_index',
      component: () => import('./index')
    },
    {
      path: 'test',
      name: 'artworkArchive_test',
      component: () => import('./test')
    },
    {
      path: 'add',
      name: 'artworkArchive_add',
      component: () => import('./addArtwork/index')
    },
    {
      path: 'detail',
      name: 'artworkArchive_detail',
      component: () => import('./artworkDetail/index')
    },
    {
      path: 'artSummary',
      name: 'artworkArchiveSummary',
      component: () => import('./artSummary')
    }
  ]
}



// WEBPACK FOOTER //
// ./src/pages/artworkArchive/router_artworkArchive.js